(function () {
  'use strict';

  var CONTAINERS = [
    '.main-article__body',
    '[itemprop="articleBody"]',
    '.main-article__content .main-article__body',
    'article .main-article__body',
  ];

  function pushEvent(name, root) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      article_handle: root.getAttribute('data-article-handle') || '',
      placement: root.getAttribute('data-placement') || '',
    });
  }

  function findContainer() {
    for (var i = 0; i < CONTAINERS.length; i++) {
      var el = document.querySelector(CONTAINERS[i]);
      if (el) return el;
    }
    return null;
  }

  function isUnsafeParagraph(el) {
    if (!el || el.tagName !== 'P') return true;
    if (el.closest('ul, ol, blockquote, figure, figcaption')) return true;
    if (el.matches('.caption, [class*="caption"]')) return true;
    return false;
  }

  function directParagraphs(container) {
    var out = [];
    var children = container.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.tagName !== 'P') continue;
      if (isUnsafeParagraph(child)) continue;
      out.push(child);
    }
    return out;
  }

  function revealInPlace(root) {
    root.classList.remove('blog-quiz-cta--pending');
    root.classList.remove('blog-quiz-cta--inline');
    root.classList.add('blog-quiz-cta--below_article');
    root.setAttribute('data-placement', 'below_article');
  }

  function placeInline(root) {
    var after = parseInt(root.getAttribute('data-after-paragraph'), 10);
    if (!after || after < 1) after = 3;

    var container = findContainer();
    if (!container) {
      revealInPlace(root);
      return;
    }

    var paras = directParagraphs(container);
    if (paras.length === 0) {
      container.appendChild(root);
    } else {
      var index = Math.min(after, paras.length) - 1;
      paras[index].insertAdjacentElement('afterend', root);
    }

    root.classList.remove('blog-quiz-cta--pending');
    root.classList.add('is-placed');
  }

  function observeView(root) {
    if (root.getAttribute('data-view-tracked') === 'true') return;

    function fire() {
      if (root.getAttribute('data-view-tracked') === 'true') return;
      root.setAttribute('data-view-tracked', 'true');
      pushEvent('blog_quiz_cta_view', root);
    }

    if (!('IntersectionObserver' in window)) {
      fire();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          fire();
          observer.disconnect();
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(root);
  }

  function bindClick(root) {
    var button = root.querySelector('[data-blog-quiz-cta-button]');
    if (!button || button.getAttribute('data-click-bound') === 'true') return;
    button.setAttribute('data-click-bound', 'true');
    button.addEventListener('click', function () {
      pushEvent('blog_quiz_cta_click', root);
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-bqc-ready') === 'true') return;
    root.setAttribute('data-bqc-ready', 'true');

    if (root.getAttribute('data-placement') === 'inline') {
      placeInline(root);
    }

    bindClick(root);
    observeView(root);
  }

  function initAll() {
    document.querySelectorAll('[data-blog-quiz-cta]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector('[data-blog-quiz-cta]');
    if (root) initRoot(root);
  });
})();
